import { useTheme as useNextTheme } from "next-themes";

import { type Theme, themes } from "#/config/theme";

export const useTheme = () => {
  const nextTheme = useNextTheme();

  const theme = nextTheme.theme as Theme;
  const isDark = theme === "dark";
  const setTheme = (value: Theme) => {
    nextTheme.setTheme(value);
  };

  return {
    theme,
    isDark,
    ...themes[theme],
    themes,
    setTheme,
    handleToggleTheme: () => {
      setTheme(isDark ? "light" : "dark");
    },
  };
};
